import classes from "./Stack.module.scss";
import { clsx } from "clsx";
import { StackProps } from "./StackProps";

export function Stack(props: StackProps) {
  const {
    children,
    className,
    gap,
    align,
    justify,
    direction = "column",
    wrap = false,
  } = props;

  return (
    <div
      className={clsx(
        classes.stack,
        classes[direction],
        wrap && classes.wrap,
        gap && classes[gap],
        align && classes[`align-${align}`],
        justify && classes[`justify-${justify}`],
        className,
      )}
    >
      {children}
    </div>
  );
}
